(function () {
  const SECTION_SELECTOR = '.section-hot-tube-water-calculator';
  const TAB_SELECTOR = '.hot-tube-water-calculator__tab';
  const PANEL_SELECTOR = '.hot-tube-water-calculator__panel';
  const LEAD_SUBMITTED_KEY = 'supa-htc-lead-submitted';
  const LEAD_DATA_KEY = 'supa-htc-lead-data';
  /** Sync with inline boot script in `sections/hot-tube-water-calculator.liquid` */
  const HTC_LEAD_GATE_BOOT_LOCK_CLASS = 'htc-lead-gate-boot-lock';
  const HTC_SCORE_URL =
    'https://hjdomxzbruxedccddyna.supabase.co/rest/v1/score?select=*&order=created_at.desc&limit=1';
  const HTC_SCORE_HEADERS = {
    Authorization:
      'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
    apikey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
  };

  const HTC_CHIP_MULTI = new Set(['hot-tub', 'swim-spa', 'pool']);
  const HTC_CHIP_EXCLUSIVE = new Set(['thinking', 'none']);

  function activateTab(section, tabId, skipScroll) {
    const tabs = section.querySelectorAll(TAB_SELECTOR);
    const panels = section.querySelectorAll(PANEL_SELECTOR);

    tabs.forEach((tab) => {
      const isActive = tab.getAttribute('data-tab') === tabId;
      tab.classList.toggle('hot-tube-water-calculator__tab--active', isActive);
      tab.classList.toggle('hot-tube-water-calculator__tab--inactive', !isActive);
      tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    panels.forEach((panel) => {
      const isMatch = panel.getAttribute('data-tab-content') === tabId;
      panel.classList.toggle('hot-tube-water-calculator__panel--hidden', !isMatch);
    });

    if (!skipScroll) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initStickyTabsOffset(section) {
    const tabsBar = section.querySelector('.hot-tube-water-calculator');
    if (!tabsBar) return;

    const header = document.querySelector('.section-header.shopify-section-group-header-group');

    const getPromoBannerHeight = () => {
      const promoBar = document.querySelector('.promo-bar-wrapper');
      if (!promoBar) return 0;
      const rect = promoBar.getBoundingClientRect();
      const isVisible = rect.height > 0 && window.getComputedStyle(promoBar).display !== 'none';
      return isVisible ? Math.round(rect.height) : 0;
    };

    const updateStickyOffset = () => {
      const promoBannerHeight = getPromoBannerHeight();
      let headerVisibleHeight = 0;
      if (header) {
        const rect = header.getBoundingClientRect();
        const visibleBottom = Math.min(rect.bottom, window.innerHeight);
        const visibleTop = Math.max(rect.top, 0);
        headerVisibleHeight = Math.max(0, visibleBottom - promoBannerHeight + 4 - visibleTop);
      }
      const tabsBarHeight = tabsBar.offsetHeight;
      const stickyTop = Math.round(promoBannerHeight + headerVisibleHeight);
      tabsBar.style.setProperty('--htc-sticky-top', `${stickyTop}px`);
      section.style.setProperty('--htc-scroll-margin', `${stickyTop + tabsBarHeight + 16}px`);
    };

    let rafId = null;
    const scheduleUpdate = () => {
      if (rafId !== null) return;
      rafId = window.requestAnimationFrame(() => {
        rafId = null;
        updateStickyOffset();
      });
    };

    updateStickyOffset();
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate);
  }

  function initSection(section) {
    const tabs = section.querySelectorAll(TAB_SELECTOR);
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        if (section.hasAttribute('data-htc-lead-gate-locked')) return;
        const tabId = tab.getAttribute('data-tab');
        if (!tabId) return;
        activateTab(section, tabId);
      });
    });

    // Ensure initial state is consistent
    const activeTab = Array.from(tabs).find((tab) => tab.getAttribute('aria-pressed') === 'true') || tabs[0];
    const initialId = activeTab ? activeTab.getAttribute('data-tab') : null;
    if (initialId) {
      activateTab(section, initialId, true);
    }
  }

  function initActiveIngredientsToggle(section) {
    const toggles = section.querySelectorAll('[data-htc-ai-toggle]');
    const defaultValues = {
      ph_up: 100,
      ph_down: 93,
      chlorine: 55,
      bromine: 61,
      alkalinity_up: 100,
      shock: 100,
    };

    toggles.forEach((toggle) => {
      if (toggle.hasAttribute('data-htc-ai-initialized')) return;
      toggle.setAttribute('data-htc-ai-initialized', 'true');

      const panel = toggle.nextElementSibling;
      if (!panel || !panel.classList.contains('htc-ai-fields')) return;

      panel.removeAttribute('hidden');
      const hint = toggle.querySelector('[data-htc-ai-hint]');

      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !isExpanded;
        toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
        panel.setAttribute('data-open', nextExpanded ? 'true' : 'false');
        panel.setAttribute('aria-hidden', nextExpanded ? 'false' : 'true');
        if (hint) {
          hint.textContent = nextExpanded ? 'Tap to collapse' : 'Tap to pop in your product percentages';
        }
      });

      const resetBtn = panel.querySelector('[data-htc-ai-reset]');
      if (resetBtn) {
        resetBtn.addEventListener('click', (e) => {
          e.preventDefault();
          for (const [key, val] of Object.entries(defaultValues)) {
            const input = panel.querySelector(`[data-htc-ingredient="${key}"]`);
            if (input) input.value = String(val);
          }
          if (typeof updateResults === 'function') updateResults(section);
        });
      }
      panel.querySelectorAll('[data-htc-ingredient]').forEach((input) => {
        input.addEventListener('input', () => {
          if (typeof updateResults === 'function') updateResults(section);
        });
        input.addEventListener('change', () => {
          if (typeof updateResults === 'function') updateResults(section);
        });
      });
    });
  }

  const VOLUME_LITRES_TO_US = 0.264172;
  const VOLUME_LITRES_TO_UK = 0.219969;

  function initWaterSetupOptions(section) {
    const card = section.querySelector('.htc-water-setup');
    if (!card) return;

    const volumeInput = card.querySelector('[data-htc-volume-input]');
    const volumeUnitSelect = card.querySelector('[data-htc-volume-unit]');
    const volumeHint = card.querySelector('[data-htc-volume-hint]');

    let volumeLitres = Number(volumeInput?.value) || 1000;

    function getDisplayValue() {
      const unit = volumeUnitSelect?.value || 'litres';
      if (unit === 'us_gallons') return Math.round(volumeLitres * VOLUME_LITRES_TO_US);
      if (unit === 'uk_gallons') return Math.round(volumeLitres * VOLUME_LITRES_TO_UK);
      return volumeLitres;
    }

    function setVolumeFromDisplay(val) {
      const unit = volumeUnitSelect?.value || 'litres';
      const num = Number(val) || 0;
      if (unit === 'us_gallons') volumeLitres = num / VOLUME_LITRES_TO_US;
      else if (unit === 'uk_gallons') volumeLitres = num / VOLUME_LITRES_TO_UK;
      else volumeLitres = num;
    }

    function syncVolumeInput() {
      if (volumeInput) volumeInput.value = String(getDisplayValue());
    }

    function updateVolumeHint(waterBody) {
      if (!volumeHint) return;
      const isHotTub = waterBody === 'hot_tub';
      volumeHint.textContent = isHotTub
        ? 'Most hot tubs hold 1,000 to 1,500 litres · Not sure? Pop over to the Volume Calculator tab'
        : 'Most pools hold 20,000 to 50,000 litres · Not sure? Pop over to the Volume Calculator tab';
    }

    const bodyButtons = card.querySelectorAll('[data-htc-water-body]');
    bodyButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        bodyButtons.forEach((b) => {
          b.classList.remove('htc-water-setup__option--selected');
          const icon = b.querySelector('.htc-water-setup__option-icon');
          if (icon) icon.classList.remove('htc-water-setup__option-icon--active');
        });
        btn.classList.add('htc-water-setup__option--selected');
        const icon = btn.querySelector('.htc-water-setup__option-icon');
        if (icon) icon.classList.add('htc-water-setup__option-icon--active');
        const waterBody = btn.getAttribute('data-htc-water-body');
        updateVolumeHint(waterBody);
        volumeLitres = waterBody === 'hot_tub' ? 1500 : 40000;
        syncVolumeInput();
        if (typeof updateResults === 'function') updateResults(section);
      });
    });

    const sanitiserButtons = card.querySelectorAll('[data-htc-sanitiser]');
    sanitiserButtons.forEach((btn) => {
      btn.addEventListener('click', () => {
        sanitiserButtons.forEach((b) => b.classList.remove('htc-water-setup__option--selected'));
        btn.classList.add('htc-water-setup__option--selected');
        if (typeof updateResults === 'function') updateResults(section);
      });
    });

    if (volumeUnitSelect) {
      volumeUnitSelect.addEventListener('change', () => {
        syncVolumeInput();
        if (typeof updateResults === 'function') updateResults(section);
      });
    }

    if (volumeInput) {
      volumeInput.addEventListener('input', () => {
        setVolumeFromDisplay(volumeInput.value);
        if (typeof updateResults === 'function') updateResults(section);
      });
      volumeInput.addEventListener('change', () => {
        syncVolumeInput();
        if (typeof updateResults === 'function') updateResults(section);
      });
    }

    const initialBody = card.querySelector('[data-htc-water-body].htc-water-setup__option--selected');
    if (initialBody) updateVolumeHint(initialBody.getAttribute('data-htc-water-body'));
  }

  function getSelectedSanitiser(section) {
    const card = section.querySelector('.htc-water-setup');
    const btn = card?.querySelector('[data-htc-sanitiser].htc-water-setup__option--selected');
    return (btn?.getAttribute('data-htc-sanitiser') || 'chlorine').toLowerCase();
  }

  function getVolumeLitres(section) {
    const card = section.querySelector('.htc-water-setup');
    const input = card?.querySelector('[data-htc-volume-input]');
    const unitSelect = card?.querySelector('[data-htc-volume-unit]');
    const unit = unitSelect?.value || 'litres';
    const displayVal = Number(input?.value) || 1000;
    if (unit === 'us_gallons') return displayVal / VOLUME_LITRES_TO_US;
    if (unit === 'uk_gallons') return displayVal / VOLUME_LITRES_TO_UK;
    return displayVal;
  }

  function getVolumeUnit(section) {
    const card = section.querySelector('.htc-water-setup');
    return card?.querySelector('[data-htc-volume-unit]')?.value || 'litres';
  }

  function getSelectedWaterBody(section) {
    const card = section.querySelector('.htc-water-setup');
    const btn = card?.querySelector('[data-htc-water-body].htc-water-setup__option--selected');
    return btn?.getAttribute('data-htc-water-body') || 'hot_tub';
  }

  function calculateVolumeLitres(shape, dims) {
    const { length = 0, width = 0, depth = 0, diameter = 0 } = dims;
    switch (shape) {
      case 'rectangular':
        return length * width * depth * 1000;
      case 'circular':
        return Math.PI * Math.pow(diameter / 2, 2) * depth * 1000;
      case 'oval':
        return Math.PI * (length / 2) * (width / 2) * depth * 1000;
      default:
        return 0;
    }
  }

  function initVolumeCalculator(section) {
    const block = section.querySelector('[data-htc-volume]');
    if (!block) return;

    const shapeBtns = block.querySelectorAll('[data-htc-shape]');
    const fieldLength = block.querySelector('[data-htc-field="length"]');
    const fieldWidth = block.querySelector('[data-htc-field="width"]');
    const fieldDiameter = block.querySelector('[data-htc-field="diameter"]');
    const labelLength = block.querySelector('[data-htc-label-length]');
    const labelWidth = block.querySelector('[data-htc-label-width]');
    const inputs = block.querySelectorAll('[data-htc-dimension]');
    const resultBlock = block.querySelector('[data-htc-volume-result]');
    const resultLitres = block.querySelector('[data-htc-result-litres]');
    const resultUs = block.querySelector('[data-htc-result-us]');
    const resultUk = block.querySelector('[data-htc-result-uk]');
    const useBtn = block.querySelector('[data-htc-volume-use]');
    const presetsHotTub = block.querySelector('[data-htc-presets="hot_tub"]');
    const presetsPool = block.querySelector('[data-htc-presets="pool"]');
    const presetsLabel = block.querySelector('[data-htc-presets-label]');

    let currentShape = 'rectangular';

    function setShape(shape) {
      currentShape = shape;
      shapeBtns.forEach((btn) => {
        const isSelected = btn.getAttribute('data-htc-shape') === shape;
        btn.classList.toggle('htc-volume__shape-btn--selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      });
      const isCircular = shape === 'circular';
      fieldLength?.classList.toggle('htc-volume__field--hidden', isCircular);
      fieldWidth?.classList.toggle('htc-volume__field--hidden', isCircular);
      fieldDiameter?.classList.toggle('htc-volume__field--hidden', !isCircular);
      if (labelLength) {
        labelLength.textContent = shape === 'oval' ? 'Longest Length (metres)' : 'Length (metres)';
      }
      if (labelWidth) {
        labelWidth.textContent = shape === 'oval' ? 'Widest Width (metres)' : 'Width (metres)';
      }
      recalcVolume();
    }

    function getDimensions() {
      const get = (name) => {
        const el = block.querySelector(`[data-htc-dimension="${name}"]`);
        return Number(el?.value) || 0;
      };
      return {
        length: get('length'),
        width: get('width'),
        depth: get('depth'),
        diameter: get('diameter'),
      };
    }

    function recalcVolume() {
      const dims = getDimensions();
      const litres = calculateVolumeLitres(currentShape, dims);
      const hasVolume = litres > 0;
      resultBlock?.classList.toggle('htc-volume__result--hidden', !hasVolume);
      if (resultLitres) resultLitres.textContent = Math.round(litres).toLocaleString();
      if (resultUs) resultUs.textContent = Math.round(litres * VOLUME_LITRES_TO_US).toLocaleString();
      if (resultUk) resultUk.textContent = Math.round(litres * VOLUME_LITRES_TO_UK).toLocaleString();
    }

    function applyVolume(litres) {
      const card = section.querySelector('.htc-water-setup');
      const volumeInput = card?.querySelector('[data-htc-volume-input]');
      const volumeUnitSelect = card?.querySelector('[data-htc-volume-unit]');
      if (!volumeInput || !volumeUnitSelect) return;
      volumeUnitSelect.value = 'litres';
      volumeInput.value = String(Math.round(litres));
      volumeInput.dispatchEvent(new Event('input', { bubbles: true }));
      volumeInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (typeof updateResults === 'function') updateResults(section);
      activateTab(section, 'calculator');
      const grid = section.querySelector('[data-htc-calculator-grid]');
      if (grid) {
        grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function updatePresetsVisibility() {
      const body = getSelectedWaterBody(section);
      const isHotTub = body === 'hot_tub';
      presetsHotTub?.classList.toggle('htc-volume__presets--hidden', !isHotTub);
      presetsPool?.classList.toggle('htc-volume__presets--hidden', isHotTub);
      if (presetsLabel) presetsLabel.textContent = isHotTub ? 'Hot Tubs' : 'Pools';
    }

    shapeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const shape = btn.getAttribute('data-htc-shape');
        if (shape) setShape(shape);
      });
    });

    inputs.forEach((input) => {
      input.addEventListener('input', recalcVolume);
      input.addEventListener('change', recalcVolume);
    });

    if (useBtn) {
      useBtn.addEventListener('click', () => {
        const dims = getDimensions();
        const litres = calculateVolumeLitres(currentShape, dims);
        if (litres > 0) applyVolume(litres);
      });
    }

    block.querySelectorAll('[data-htc-preset-litres]').forEach((presetBtn) => {
      presetBtn.addEventListener('click', () => {
        const litres = Number(presetBtn.getAttribute('data-htc-preset-litres')) || 0;
        if (litres > 0) applyVolume(litres);
      });
    });

    const waterSetup = section.querySelector('.htc-water-setup');
    waterSetup?.querySelectorAll('[data-htc-water-body]').forEach((btn) => {
      btn.addEventListener('click', () => updatePresetsVisibility());
    });

    updatePresetsVisibility();
    recalcVolume();
  }

  function getReadingsState(section) {
    const readings = section.querySelector('.htc-readings');
    if (!readings) return { currentAlkalinity: 100, currentPh: 7.4, currentChlorine: 3, currentBromine: 3 };
    const getVal = (key) => {
      const row = readings.querySelector(`.htc-reading[data-htc-reading="${key}"]`);
      if (!row || row.classList.contains('htc-reading--hidden')) return null;
      const el = row.querySelector('[data-htc-value]') || row.querySelector('[data-htc-range]');
      return el ? Number(el.value) : null;
    };
    return {
      currentAlkalinity: getVal('total_alkalinity') ?? 100,
      currentPh: getVal('ph') ?? 7.4,
      currentChlorine: getVal('free_chlorine') ?? 3,
      currentBromine: getVal('bromine') ?? 3,
    };
  }

  function getActiveIngredients(section) {
    const defaults = {
      ph_up: 100,
      ph_down: 93,
      chlorine: 55,
      bromine: 61,
      alkalinity_up: 100,
      alkalinity_down: 93,
      shock: 100,
    };
    const panel = section.querySelector('.htc-ai-fields');
    if (!panel) return defaults;
    const out = { ...defaults };
    ['ph_up', 'ph_down', 'chlorine', 'bromine', 'alkalinity_up', 'alkalinity_down', 'shock'].forEach((key) => {
      const input = panel.querySelector(`[data-htc-ingredient="${key}"]`);
      if (input) out[key] = Number(input.value) || defaults[key];
    });
    return out;
  }

  function updateReadingsSanitiser(section) {
    const readings = section.querySelector('.htc-readings');
    if (!readings) return;
    const sanitiser = getSelectedSanitiser(section);
    const rows = readings.querySelectorAll('.htc-reading[data-htc-sanitiser]');
    rows.forEach((row) => {
      const rowSanitiser = (row.getAttribute('data-htc-sanitiser') || '').toLowerCase();
      row.classList.toggle('htc-reading--hidden', rowSanitiser !== sanitiser);
    });
  }

  function updateIdealBand(row) {
    const min = Number(row.getAttribute('data-htc-min')) || 0;
    const max = Number(row.getAttribute('data-htc-max')) || 100;
    const idealMin = Number(row.getAttribute('data-htc-ideal-min')) || min;
    const idealMax = Number(row.getAttribute('data-htc-ideal-max')) || max;
    const range = max - min;
    if (range <= 0) return;
    const left = ((idealMin - min) / range) * 100;
    const width = ((idealMax - idealMin) / range) * 100;
    const band = row.querySelector('[data-htc-ideal-range]');
    if (band) {
      band.style.left = `${left}%`;
      band.style.width = `${width}%`;
    }
  }

  function getStatus(value, idealMin, idealMax) {
    const v = Number(value);
    if (v < idealMin) return 'low';
    if (v > idealMax) return 'high';
    return 'ideal';
  }

  function getStatusLabel(status) {
    if (status === 'low') return 'Too low';
    if (status === 'high') return 'Too high';
    return 'Spot on ✓';
  }

  function updateReadingStatus(row) {
    const valueEl = row.querySelector('[data-htc-value]');
    const rangeEl = row.querySelector('[data-htc-range]');
    const value = valueEl ? Number(valueEl.value) : rangeEl ? Number(rangeEl.value) : 0;
    const idealMin = Number(row.getAttribute('data-htc-ideal-min')) || 0;
    const idealMax = Number(row.getAttribute('data-htc-ideal-max')) || 100;
    const status = getStatus(value, idealMin, idealMax);
    const statusEl = row.querySelector('[data-htc-status]');
    if (statusEl) {
      statusEl.textContent = getStatusLabel(status);
      statusEl.classList.remove('htc-reading__status--low', 'htc-reading__status--high', 'htc-reading__status--ideal');
      statusEl.classList.add(`htc-reading__status--${status}`);
    }
  }

  function clampValue(value, min, max, step) {
    const v = Number(value);
    if (Number.isNaN(v)) return min;
    const s = Number(step) || 1;
    const rounded = Math.round(v / s) * s;
    return Math.min(max, Math.max(min, rounded));
  }

  function formatReadingValue(value, step) {
    const s = Number(step) || 1;
    if (s < 1) return Number(value).toFixed(1);
    return String(Math.round(value));
  }

  function syncReadingInputs(row) {
    const rangeEl = row.querySelector('[data-htc-range]');
    const valueEl = row.querySelector('[data-htc-value]');
    const min = Number(row.getAttribute('data-htc-min')) || 0;
    const max = Number(row.getAttribute('data-htc-max')) || 100;
    const step = Number(row.getAttribute('data-htc-step')) || 1;
    if (!rangeEl || !valueEl) return;
    const value = clampValue(valueEl.value, min, max, step);
    const formatted = formatReadingValue(value, step);
    valueEl.value = formatted;
    rangeEl.value = formatted;
    updateReadingStatus(row);
  }

  function initReadings(section) {
    const readings = section.querySelector('.htc-readings');
    if (!readings) return;

    updateReadingsSanitiser(section);
    const waterSetup = section.querySelector('.htc-water-setup');
    const sanitiserBtns = waterSetup?.querySelectorAll('[data-htc-sanitiser]');
    sanitiserBtns?.forEach((btn) => {
      btn.addEventListener('click', () => updateReadingsSanitiser(section));
    });

    const rows = readings.querySelectorAll('.htc-reading');
    rows.forEach((row) => {
      updateIdealBand(row);
      const rangeEl = row.querySelector('[data-htc-range]');
      const valueEl = row.querySelector('[data-htc-value]');
      const min = Number(row.getAttribute('data-htc-min')) || 0;
      const max = Number(row.getAttribute('data-htc-max')) || 100;
      const step = Number(row.getAttribute('data-htc-step')) || 1;

      if (rangeEl) {
        rangeEl.addEventListener('input', () => {
          const value = clampValue(rangeEl.value, min, max, step);
          const formatted = formatReadingValue(value, step);
          if (valueEl) valueEl.value = formatted;
          rangeEl.value = formatted;
          updateReadingStatus(row);
          if (typeof updateResults === 'function') updateResults(section);
        });
      }
      if (valueEl) {
        valueEl.addEventListener('input', () => {
          syncReadingInputs(row);
          if (typeof updateResults === 'function') updateResults(section);
        });
        valueEl.addEventListener('change', () => {
          syncReadingInputs(row);
          if (typeof updateResults === 'function') updateResults(section);
        });
      }
      updateReadingStatus(row);
    });
  }

  const DOSING_RATES = {
    ph_up: {
      chemical: 'pH Plus (Soda Ash) - please add no more than 20 g per dose and wait 30 mins before retesting',
      gramsPerUnitPer1000L: 10,
      unitSize: 0.1,
      unit: 'g',
      instructions: [
        'Grab your granules and weigh them out — digital scales are best, or use a level teaspoon (about 5g)',
        'Pop the granules into a clean bucket of warm water and give it a stir until dissolved',
        'With your jets running, slowly pour the solution in near an inlet',
        'Give it 20–30 minutes with the jets on, then re-test',
        'Keep it to no more than 20g (four level teaspoons) per 1,000 litres in one go',
      ],
      safetyNotes: [
        'Pop on some gloves and eye protection before handling',
        'Never mix with other chemicals',
        'Keep stored in a cool, dry spot away from acids',
      ],
    },
    ph_down: {
      chemical: 'pH Minus (Sodium Bisulphate)',
      gramsPerUnitPer1000L: 10,
      unitSize: 0.1,
      unit: 'g',
      instructions: [
        'Weigh out the granules — digital scales are ideal, or use a level teaspoon (about 7g for this one)',
        'Dissolve in a clean bucket of warm water first',
        'Pour it into the water with the jets running',
        'Wait 20–30 minutes with jets on, then test again',
        'Stick to 25g max (roughly three and a half level teaspoons) per 1,000 litres at a time',
      ],
      safetyNotes: [
        'Gloves and eye protection are a must for this one',
        'This is an acid — never mix it with chlorine or other chemicals',
        'Always add the chemical to the water, not the other way round',
      ],
    },
    chlorine_granules: {
      chemical: 'Chlorine Granules (Dichlor)',
      gramsPerPpmPer1000L: 2,
      unit: 'g',
      instructions: [
        'Use granules, not tablets — weigh them out with scales or use a level teaspoon (about 5g)',
        'Dissolve the granules in a bucket of warm water before adding — never put them straight in',
        'With your circulation running, pour the solution evenly across the water',
        'Leave it 20-30 minutes with the jest on before retesting',
        "Keep levels below 10 ppm — if they're high, just wait for them to come down naturally",
      ],
      safetyNotes: [
        'Always dissolve first — never sprinkle chlorine granules directly into the water',
        'Never mix chlorine with bromine or acids',
        'Give your hands a good wash after handling',
      ],
    },
    bromine_granules: {
      chemical: 'Bromine Granules',
      gramsPerPpmPer1000L: 3,
      unit: 'g',
      instructions: [
        'Use granules, not tablets — weigh them out with scales or use a level teaspoon (about 5g)',
        'Dissolve the granules in a bucket of warm water before adding',
        'Pour the solution in with the jets running',
        'Give it 20–30 minutes with the jets on before you take a dip',
        "You're looking for 3–5 ppm for hot tubs",
      ],
      safetyNotes: [
        'Never mix bromine with chlorine — pick one and stick with it',
        'Wear gloves when handling',
        'Store this separately from all your other chemicals',
      ],
    },
    alkalinity_up: {
      chemical: 'Alkalinity Increaser (Sodium Bicarbonate)',
      gramsPerPpmPer1000L: 1.5,
      unit: 'g',
      instructions: [
        'Weigh out what you need — scales are best, or a level teaspoon is about 5g',
        'Dissolve in a bucket of warm water',
        'Add it gradually to the water with the circulation going',
        'Wait 20–30 minutes with the jets running, then re-test. Alkalinity can take a bit longer to settle — check again in a couple of hours if needed',
        'Keep it to 50g max (ten level teaspoons) per 1,000 litres at a time',
      ],
      safetyNotes: ["This one's fairly gentle, but pop on some gloves as good practice", 'Keep it away from acids'],
    },
    alkalinity_down: {
      chemical: 'pH Minus (Sodium Bisulphate)',
      gramsPerPpmPer1000L: 1.2,
      unit: 'g',
      instructions: [
        'Weigh the granules out — scales are best, or a level teaspoon is about 7g',
        'pH Minus does double duty here — it brings down both alkalinity and pH',
        'Dissolve and add with the jets on high for good circulation',
        "This is a bit of a gradual process — repeat every 24 hours until you're in range",
      ],
      safetyNotes: ['This is an acid, so handle with care', 'Gloves and eye protection are a must'],
    },
    shock: {
      chemical: 'Non-Chlorine Shock (MPS)',
      gramsPerDosePer1000L: 35,
      unit: 'g',
      instructions: [
        'Weigh out the granules — scales or a level teaspoon (about 5g) will do the job',
        'Dissolve in a bucket of warm water first',
        'Add to the tub with the cover off and jets running',
        'Leave the cover off for at least 20 minutes to let it do its thing',
        'Hold off on bathing for at least 20 minutes after shocking',
      ],
      safetyNotes: [
        "Make sure there's good ventilation — don't shock in an enclosed space",
        'Gloves and eye protection please',
        'Works nicely with both chlorine and bromine setups',
      ],
    },
  };

  function adjustForConcentration(rawGrams, activePercent) {
    if (activePercent <= 0 || activePercent > 100) return rawGrams;
    return rawGrams / (activePercent / 100);
  }

  function getParamStatus(value, idealMin, idealMax) {
    const v = Number(value);
    if (v < idealMin) return 'low';
    if (v > idealMax) return 'high';
    return 'ideal';
  }

  function calcAlkalinityDosing(currentPpm, volumeLitres, activePercent) {
    const idealMin = 80,
      idealMax = 120;
    const targetPpm = 100;
    const status = getParamStatus(currentPpm, idealMin, idealMax);
    if (status === 'ideal')
      return {
        parameter: 'Total Alkalinity',
        chemical: 'None needed',
        amount: 0,
        unit: 'g',
        action: "Nothing to do here — you're all good",
        status: 'ideal',
        instructions: ['Your alkalinity is spot on. That makes everything else easier!'],
        safetyNotes: [],
        priority: 'low',
      };
    if (status === 'low') {
      const rate = DOSING_RATES.alkalinity_up;
      const ppmNeeded = targetPpm - currentPpm;
      const rawGrams = ppmNeeded * rate.gramsPerPpmPer1000L * (volumeLitres / 1000);
      const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
      return {
        parameter: 'Total Alkalinity',
        chemical: rate.chemical,
        amount,
        unit: rate.unit,
        action: `Alkalinity is ${currentPpm} ppm — let's bring it up to ${targetPpm} ppm`,
        status: 'low',
        instructions: rate.instructions,
        safetyNotes: rate.safetyNotes,
        priority: currentPpm < 40 ? 'high' : 'medium',
      };
    }
    const rate = DOSING_RATES.alkalinity_down;
    const ppmNeeded = currentPpm - targetPpm;
    const rawGrams = ppmNeeded * rate.gramsPerPpmPer1000L * (volumeLitres / 1000);
    const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
    return {
      parameter: 'Total Alkalinity',
      chemical: rate.chemical,
      amount,
      unit: rate.unit,
      action: `Alkalinity is ${currentPpm} ppm — let's bring it down to ${targetPpm} ppm`,
      status: 'high',
      instructions: rate.instructions,
      safetyNotes: rate.safetyNotes,
      priority: currentPpm > 180 ? 'high' : 'medium',
    };
  }

  function calcPhDosing(currentPh, volumeLitres, activePercent) {
    const idealMin = 7.2,
      idealMax = 7.6;
    const targetPh = 7.4;
    const status = getParamStatus(currentPh, idealMin, idealMax);
    if (status === 'ideal')
      return {
        parameter: 'pH',
        chemical: 'None needed',
        amount: 0,
        unit: 'g',
        action: "Nothing to do here — you're all good",
        status: 'ideal',
        instructions: ['Your pH is spot on. No adjustment needed — nice one!'],
        safetyNotes: [],
        priority: 'low',
      };
    if (status === 'low') {
      const rate = DOSING_RATES.ph_up;
      const difference = targetPh - currentPh;
      const units = difference / rate.unitSize;
      const rawGrams = units * rate.gramsPerUnitPer1000L * (volumeLitres / 1000);
      const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
      return {
        parameter: 'pH',
        chemical: rate.chemical,
        amount,
        unit: rate.unit,
        action: `Your pH is ${currentPh} — let's bring it up to ${targetPh}`,
        status: 'low',
        instructions: rate.instructions,
        safetyNotes: rate.safetyNotes,
        priority: currentPh < 7.0 ? 'high' : 'medium',
      };
    }
    const rate = DOSING_RATES.ph_down;
    const difference = currentPh - targetPh;
    const units = difference / rate.unitSize;
    const rawGrams = units * rate.gramsPerUnitPer1000L * (volumeLitres / 1000);
    const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
    return {
      parameter: 'pH',
      chemical: rate.chemical,
      amount,
      unit: rate.unit,
      action: `Your pH is ${currentPh} — let's bring it down to ${targetPh}`,
      status: 'high',
      instructions: rate.instructions,
      safetyNotes: rate.safetyNotes,
      priority: currentPh > 8.0 ? 'high' : 'medium',
    };
  }

  function calcChlorineDosing(currentPpm, volumeLitres, activePercent) {
    const idealMin = 3,
      idealMax = 5;
    const targetPpm = 4;
    const status = getParamStatus(currentPpm, idealMin, idealMax);
    if (status === 'ideal')
      return {
        parameter: 'Free Chlorine',
        chemical: 'None needed',
        amount: 0,
        unit: 'g',
        action: "Nothing to do here — you're all good",
        status: 'ideal',
        instructions: ['Your chlorine is right where it should be. Happy days!'],
        safetyNotes: [],
        priority: 'low',
      };
    if (status === 'low') {
      const rate = DOSING_RATES.chlorine_granules;
      const ppmNeeded = targetPpm - currentPpm;
      const rawGrams = ppmNeeded * rate.gramsPerPpmPer1000L * (volumeLitres / 1000);
      const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
      return {
        parameter: 'Free Chlorine',
        chemical: rate.chemical,
        amount,
        unit: rate.unit,
        action: `Chlorine is ${currentPpm} ppm — let's top it up to ${targetPpm} ppm`,
        status: 'low',
        instructions: rate.instructions,
        safetyNotes: rate.safetyNotes,
        priority: currentPpm < 1.0 ? 'high' : 'medium',
      };
    }
    return {
      parameter: 'Free Chlorine',
      chemical: 'No chemical needed — just let it come down naturally',
      amount: 0,
      unit: 'g',
      action: `Chlorine is sitting at ${currentPpm} ppm — hold off adding any more`,
      status: 'high',
      instructions: [
        'Give the tub a miss until chlorine drops below 5 ppm',
        'Pop the cover off to help it come down faster',
        'Running the jets with the cover off speeds things up too',
        'Check again in 4 to 6 hours',
      ],
      safetyNotes: ["Don't add any more chlorine or shock", 'Chlorine above 10 ppm can irritate your skin and eyes'],
      priority: currentPpm > 10 ? 'high' : 'medium',
    };
  }

  function calcBromineDosing(currentPpm, volumeLitres, activePercent) {
    const idealMin = 3,
      idealMax = 5;
    const targetPpm = 4;
    const status = getParamStatus(currentPpm, idealMin, idealMax);
    if (status === 'ideal')
      return {
        parameter: 'Bromine',
        chemical: 'None needed',
        amount: 0,
        unit: 'g',
        action: "Nothing to do here — you're all good",
        status: 'ideal',
        instructions: ['Your bromine is right where it should be. Lovely stuff!'],
        safetyNotes: [],
        priority: 'low',
      };
    if (status === 'low') {
      const rate = DOSING_RATES.bromine_granules;
      const ppmNeeded = targetPpm - currentPpm;
      const rawGrams = ppmNeeded * rate.gramsPerPpmPer1000L * (volumeLitres / 1000);
      const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
      return {
        parameter: 'Bromine',
        chemical: rate.chemical,
        amount,
        unit: rate.unit,
        action: `Bromine is ${currentPpm} ppm — let's top it up to ${targetPpm} ppm`,
        status: 'low',
        instructions: rate.instructions,
        safetyNotes: rate.safetyNotes,
        priority: currentPpm < 1.0 ? 'high' : 'medium',
      };
    }
    return {
      parameter: 'Bromine',
      chemical: 'No chemical needed — just let it come down naturally',
      amount: 0,
      unit: 'g',
      action: `Bromine is sitting at ${currentPpm} ppm — hold off adding any more`,
      status: 'high',
      instructions: [
        'Give the tub a miss until bromine drops below 5 ppm',
        'Pop the cover off to help it come down',
        'Bromine takes a bit longer than chlorine to drop, so just be patient',
        'Check again in 6 to 8 hours',
      ],
      safetyNotes: ["Don't add any more bromine", 'Bromine above 10 ppm can irritate your skin'],
      priority: currentPpm > 10 ? 'high' : 'medium',
    };
  }

  function calcShockDose(volumeLitres, activePercent) {
    const rate = DOSING_RATES.shock;
    const rawGrams = rate.gramsPerDosePer1000L * (volumeLitres / 1000);
    const amount = Math.round(adjustForConcentration(rawGrams, activePercent) * 10) / 10;
    return {
      parameter: 'Shock',
      chemical: rate.chemical,
      amount,
      unit: rate.unit,
      action: 'Your weekly shock dose — keeps things fresh and clear',
      status: 'low',
      instructions: rate.instructions,
      safetyNotes: rate.safetyNotes,
      priority: 'medium',
    };
  }

  function gramsToOz(grams) {
    return grams * 0.035274;
  }

  function formatDose(grams, useOz) {
    if (grams === 0) return useOz ? '0 oz' : '0g';
    if (useOz) {
      const oz = gramsToOz(grams);
      if (oz < 0.1) return (oz * 16).toFixed(1) + ' drams';
      if (oz >= 16) return (oz / 16).toFixed(1) + ' lb';
      return oz.toFixed(1) + ' oz';
    }
    if (grams < 1) return (grams * 1000).toFixed(0) + 'mg';
    if (grams >= 1000) return (grams / 1000).toFixed(1) + 'kg';
    return grams.toFixed(1) + 'g';
  }

  function getStatusBgClass(status) {
    if (status === 'low') return 'htc-result-card--low';
    if (status === 'high') return 'htc-result-card--high';
    return 'htc-result-card--ideal';
  }

  function escapeHtml(s) {
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  function buildResultCard(result, useOz) {
    const statusBg = getStatusBgClass(result.status);
    const priorityBadge = 'htc-result-card__priority--' + result.priority;
    const doseStr = result.amount > 0 ? formatDose(result.amount, useOz) : '';
    const metricNote = useOz && result.amount > 0 ? ' (' + formatDose(result.amount, false) + ' metric)' : '';
    let html = '<div class="htc-result-card ' + statusBg + '">';
    html += '<div class="htc-result-card__head">';
    html +=
      '<div class="htc-result-card__title-wrap"><span class="htc-result-card__status-icon" aria-hidden="true"></span><h3 class="htc-result-card__title">' +
      escapeHtml(result.parameter) +
      '</h3></div>';
    html +=
      '<span class="htc-result-card__priority ' + priorityBadge + '">' + escapeHtml(result.priority) + '</span></div>';
    html += '<p class="htc-result-card__action">' + escapeHtml(result.action) + '</p>';
    if (result.amount > 0) {
      html +=
        '<div class="htc-result-card__dose"><span class="htc-result-card__dose-value">' +
        escapeHtml(doseStr) +
        '</span> <span class="htc-result-card__dose-chemical">of ' +
        escapeHtml(result.chemical) +
        '</span></div>';
      if (metricNote) html += '<p class="htc-result-card__dose-metric">' + escapeHtml(metricNote) + '</p>';
    } else if (result.status !== 'ideal') {
      html +=
        '<div class="htc-result-card__dose"><span class="htc-result-card__dose-chemical">' +
        escapeHtml(result.chemical) +
        '</span></div>';
    }
    html +=
      '<div class="htc-result-card__howto" data-open="false"><button type="button" class="htc-result-card__howto-summary" aria-expanded="false"><span class="htc-result-card__howto-chevron" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg></span><span class="htc-result-card__howto-summary-text">Show how-to</span></button><div class="htc-result-card__howto-content"><div class="htc-result-card__howto-content-inner">';
    if (result.instructions && result.instructions.length) {
      html +=
        '<div class="htc-result-card__howto-block"><h4 class="htc-result-card__howto-heading">Here\'s What To Do</h4><ol class="htc-result-card__howto-list">';
      result.instructions.forEach((step, i) => {
        html += '<li><span class="htc-result-card__howto-num">' + (i + 1) + '.</span> ' + escapeHtml(step) + '</li>';
      });
      html += '</ol></div>';
    }
    if (result.safetyNotes && result.safetyNotes.length) {
      html +=
        '<div class="htc-result-card__safety"><h4 class="htc-result-card__safety-heading">Heads Up</h4><ul class="htc-result-card__safety-list">';
      result.safetyNotes.forEach((note) => {
        html += '<li>' + escapeHtml(note) + '</li>';
      });
      html += '</ul></div>';
    }
    html += '</div></div></div></div>';
    return html;
  }

  function updateResults(section) {
    const resultsEl = section.querySelector('[data-htc-results]');
    if (!resultsEl) return;
    const volumeLitres = getVolumeLitres(section);
    const volumeUnit = getVolumeUnit(section);
    const sanitiser = getSelectedSanitiser(section);
    const useOz = volumeUnit === 'us_gallons';
    const readings = getReadingsState(section);
    const active = getActiveIngredients(section);

    const volumeDisplay =
      volumeUnit === 'us_gallons'
        ? Math.round(volumeLitres * VOLUME_LITRES_TO_US).toLocaleString() + ' US gallons'
        : volumeUnit === 'uk_gallons'
          ? Math.round(volumeLitres * VOLUME_LITRES_TO_UK).toLocaleString() + ' UK gallons'
          : volumeLitres.toLocaleString() + ' litres';
    const sanitiserLabel = sanitiser === 'bromine' ? 'Bromine' : 'Chlorine';
    const subtitle = resultsEl.querySelector('[data-htc-results-subtitle]');
    if (subtitle) {
      subtitle.textContent =
        'Tailored for ' + volumeDisplay + ' · ' + sanitiserLabel + (useOz ? ' · Doses shown in oz' : '');
    }

    const resultsList = [];
    const alk = calcAlkalinityDosing(readings.currentAlkalinity, volumeLitres, active.alkalinity_up);
    if (alk) resultsList.push(alk);
    const ph = calcPhDosing(readings.currentPh, volumeLitres, active.ph_up);
    if (ph) resultsList.push(ph);
    if (sanitiser === 'bromine') {
      const br = calcBromineDosing(readings.currentBromine, volumeLitres, active.bromine);
      if (br) resultsList.push(br);
    } else {
      const cl = calcChlorineDosing(readings.currentChlorine, volumeLitres, active.chlorine);
      if (cl) resultsList.push(cl);
    }
    resultsList.push(calcShockDose(volumeLitres, active.shock));

    const priorityOrder = { high: 0, medium: 1, low: 2 };
    resultsList.sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
    const actionNeeded = resultsList.filter((r) => r.status !== 'ideal');
    const inRange = resultsList.filter((r) => r.status === 'ideal');

    const allGoodEl = resultsEl.querySelector('[data-htc-results-all-good]');
    const actionSection = resultsEl.querySelector('[data-htc-results-action-needed]');
    const inRangeSection = resultsEl.querySelector('[data-htc-results-in-range]');
    const actionList = resultsEl.querySelector('[data-htc-results-action-list]');
    const inRangeList = resultsEl.querySelector('[data-htc-results-in-range-list]');
    if (allGoodEl) allGoodEl.classList.toggle('htc-results__all-good--hidden', actionNeeded.length > 0);
    if (actionSection) {
      actionSection.classList.toggle('htc-results__section--hidden', actionNeeded.length === 0);
      const countEl = actionSection.querySelector('[data-htc-results-action-count]');
      if (countEl) countEl.textContent = String(actionNeeded.length);
      if (actionList) {
        actionList.innerHTML = actionNeeded.map((r) => buildResultCard(r, useOz)).join('');
      }
    }
    if (inRangeSection) {
      inRangeSection.classList.toggle('htc-results__section--hidden', inRange.length === 0);
      const countEl = inRangeSection.querySelector('[data-htc-results-in-range-count]');
      if (countEl) countEl.textContent = String(inRange.length);
      if (inRangeList) {
        inRangeList.innerHTML = inRange.map((r) => buildResultCard(r, useOz)).join('');
      }
    }

    const statusIcons = resultsEl.querySelectorAll('.htc-result-card__status-icon');
    statusIcons.forEach((el) => {
      const card = el.closest('.htc-result-card');
      if (!card) return;
      const isLow = card.classList.contains('htc-result-card--low');
      const isHigh = card.classList.contains('htc-result-card--high');
      el.setAttribute('aria-label', isLow ? 'Low' : isHigh ? 'High' : 'Ideal');
    });
  }

  function initResults(section) {
    const resultsEl = section.querySelector('[data-htc-results]');
    if (resultsEl && !resultsEl.hasAttribute('data-htc-results-howto-bound')) {
      resultsEl.setAttribute('data-htc-results-howto-bound', 'true');
      resultsEl.addEventListener('click', (e) => {
        const btn = e.target.closest('.htc-result-card__howto-summary');
        if (!btn) return;
        const howto = btn.closest('.htc-result-card__howto');
        if (!howto) return;
        const open = howto.getAttribute('data-open') === 'true';
        howto.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        const textEl = howto.querySelector('.htc-result-card__howto-summary-text');
        if (textEl) textEl.textContent = open ? 'Show how-to' : 'Hide how-to';
      });
    }
    updateResults(section);
  }

  function initGuide(section) {
    const guide = section.querySelector('[data-htc-guide]');
    if (!guide || guide.hasAttribute('data-htc-guide-bound')) return;
    guide.setAttribute('data-htc-guide-bound', 'true');

    guide.addEventListener('click', (event) => {
      const button = event.target.closest('.htc-guide-step__toggle');
      if (!button) return;
      const step = button.closest('.htc-guide-step');
      if (!step) return;
      const isOpen = step.getAttribute('data-open') === 'true';
      const nextOpen = !isOpen;
      step.setAttribute('data-open', nextOpen ? 'true' : 'false');
      button.setAttribute('aria-expanded', nextOpen ? 'true' : 'false');
      const chevron = step.querySelector('.htc-guide-step__chevron-svg');
      if (chevron) {
        chevron.classList.toggle('htc-guide-step__chevron-svg--open', nextOpen);
      }
    });
  }

  /**
   * Searchable country combobox: syncs hidden native select (name=country) for FormData and Klaviyo.
   * @param {HTMLFormElement} form
   */
  function initHtcCountryCombobox(form) {
    const root = form.querySelector('[data-htc-country-combobox]');
    if (!root) return;
    const selectEl = form.querySelector('select[data-htc-lead-input="country"]');
    const inputEl = root.querySelector('[data-htc-country-combobox-input]');
    const listEl = root.querySelector('[data-htc-country-combobox-list]');
    const toggleEl = root.querySelector('[data-htc-country-combobox-toggle]');
    if (!selectEl || !inputEl || !listEl) return;

    const optionNodes = () => listEl.querySelectorAll('[data-htc-country-option]');

    function isDividerCountryOption(opt) {
      if (!opt || opt.disabled) return true;
      const label = (opt.textContent || '').trim();
      if (!label) return false;
      return /^[\s\-–—―·]+$/u.test(label);
    }

    Array.from(selectEl.querySelectorAll('option')).forEach((opt) => {
      if (isDividerCountryOption(opt)) opt.remove();
    });

    function countryRows() {
      return Array.from(selectEl.options)
        .filter((o) => o.value !== '' && !isDividerCountryOption(o))
        .map((o) => ({
          value: o.value,
          label: (o.textContent || '').trim(),
        }));
    }

    function selectedLabel() {
      const opt = selectEl.selectedOptions[0];
      return opt && selectEl.value ? (opt.textContent || '').trim() : '';
    }

    function syncInput() {
      inputEl.value = selectedLabel();
    }

    function setNativeValue(value) {
      selectEl.value = value;
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function clearIfMismatch() {
      const label = selectedLabel();
      if (inputEl.value.trim() !== label) setNativeValue('');
    }

    /** @param {string} filterText */
    function renderOptions(filterText) {
      const q = filterText.trim().toLowerCase();
      const rows = countryRows();
      const filtered = q ? rows.filter((r) => r.label.toLowerCase().includes(q)) : rows;

      listEl.replaceChildren();
      inputEl.removeAttribute('aria-activedescendant');

      if (filtered.length === 0) {
        const empty = document.createElement('li');
        empty.className = 'htc-lead-gate__combobox-empty';
        empty.textContent = 'No countries match';
        empty.setAttribute('role', 'presentation');
        listEl.appendChild(empty);
        return;
      }

      const listId = listEl.id;
      filtered.forEach((r, i) => {
        const li = document.createElement('li');
        li.className = 'htc-lead-gate__combobox-option';
        li.setAttribute('role', 'option');
        li.setAttribute('data-htc-country-option', '');
        li.setAttribute('data-value', r.value);
        li.id = listId ? `${listId}-opt-${i}` : `htc-country-opt-${i}`;
        li.textContent = r.label;
        const isSel = r.value === selectEl.value;
        li.setAttribute('aria-selected', isSel ? 'true' : 'false');
        listEl.appendChild(li);
      });
    }

    let listOpen = false;
    /** @type {number} */
    let activeIdx = -1;
    let suppressFocusOpen = false;

    function setOpen(open) {
      listOpen = open;
      listEl.hidden = !open;
      inputEl.setAttribute('aria-expanded', open ? 'true' : 'false');
      root.classList.toggle('htc-lead-gate__combobox--open', open);
      if (!open) {
        activeIdx = -1;
        optionNodes().forEach((n) => n.classList.remove('htc-lead-gate__combobox-option--active'));
        inputEl.removeAttribute('aria-activedescendant');
      }
    }

    function highlightActive() {
      const nodes = optionNodes();
      nodes.forEach((node, i) =>
        node.classList.toggle('htc-lead-gate__combobox-option--active', i === activeIdx)
      );
      const cur = nodes[activeIdx];
      if (cur) {
        inputEl.setAttribute('aria-activedescendant', cur.id);
        cur.scrollIntoView({ block: 'nearest' });
      } else {
        inputEl.removeAttribute('aria-activedescendant');
      }
    }

    function openAndRender() {
      clearIfMismatch();
      renderOptions(inputEl.value);
      setOpen(true);
    }

    function pickIndex(idx) {
      const nodes = optionNodes();
      const li = nodes[idx];
      if (!li || !li.dataset.value) return;
      setNativeValue(li.dataset.value);
      syncInput();
      setOpen(false);
      inputEl.focus();
    }

    toggleEl?.addEventListener('click', (e) => {
      e.preventDefault();
      if (listOpen) {
        suppressFocusOpen = true;
        setOpen(false);
      }
      inputEl.focus();
    });

    inputEl.addEventListener('input', () => {
      clearIfMismatch();
      renderOptions(inputEl.value);
      setOpen(true);
      activeIdx = -1;
    });

    inputEl.addEventListener('focus', () => {
      if (suppressFocusOpen) {
        suppressFocusOpen = false;
        return;
      }
      openAndRender();
      activeIdx = -1;
    });

    inputEl.addEventListener('keydown', (e) => {
      const nodes = optionNodes();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (!listOpen) openAndRender();
        activeIdx = Math.min(activeIdx + 1, nodes.length - 1);
        if (nodes.length && activeIdx < 0) activeIdx = 0;
        highlightActive();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        if (!listOpen) openAndRender();
        activeIdx = Math.max(activeIdx - 1, 0);
        highlightActive();
      } else if (e.key === 'Enter' && listOpen && activeIdx >= 0) {
        e.preventDefault();
        pickIndex(activeIdx);
      } else if (e.key === 'Escape') {
        if (listOpen) {
          e.preventDefault();
          syncInput();
          setOpen(false);
        }
      }
    });

    listEl.addEventListener('mousedown', (e) => {
      if (e.target.closest('[data-htc-country-option]')) e.preventDefault();
    });

    listEl.addEventListener('click', (e) => {
      const li = e.target.closest('[data-htc-country-option]');
      if (!li || !li.dataset.value) return;
      setNativeValue(li.dataset.value);
      syncInput();
      setOpen(false);
      inputEl.focus();
    });

    document.addEventListener('click', (e) => {
      if (!root.contains(/** @type {Node} */ (e.target))) setOpen(false);
    });

    syncInput();
    renderOptions('');
    setOpen(false);
  }

  /** Trustpilot-style square star (inline SVG — clip-path is unreliable in WebKit inside overflow:hidden). */
  const HTC_GATE_TP_STAR_PATH =
    'M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z';

  /** @param {boolean} filled */
  function htcGateTpStarSvg(filled) {
    const rectFill = filled ? '#00b67a' : '#dcdce6';
    const starPath = filled
      ? `<g transform="translate(2 2) scale(0.75)"><path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="${HTC_GATE_TP_STAR_PATH}"></path></g>`
      : `<g transform="translate(2 2) scale(0.75)"><path fill-rule="evenodd" clip-rule="evenodd" fill="#b0b0b0" d="${HTC_GATE_TP_STAR_PATH}"></path></g>`;
    return `<span class="gate__tp-star"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><rect width="16" height="16" fill="${rectFill}"></rect>${starPath}</svg></span>`;
  }

  /** @param {number} trustScore */
  function htcGateTpStarsInnerHtml(trustScore) {
    const n = Number(trustScore);
    const full = Number.isFinite(n) ? Math.min(5, Math.max(0, Math.ceil(n))) : 0;
    let html = '';
    for (let i = 0; i < 5; i++) {
      html += htcGateTpStarSvg(i < full);
    }
    return html;
  }

  /**
   * @param {HTMLElement | null} gateHost .htc-access-gate
   * @param {{ trustScore?: unknown, numberOfReviews?: unknown } | null} row
   */
  function applyHtcGateScoreRow(gateHost, row) {
    if (!gateHost) return;
    const trust = row != null ? Number(row.trustScore) : NaN;
    const count = row != null ? Number(row.numberOfReviews) : NaN;
    const starsEl = gateHost.querySelector('[data-htc-gate-tp-stars]');
    const strongEl = gateHost.querySelector('[data-htc-gate-tp-strong]');
    const line2 = gateHost.querySelector('[data-htc-gate-tp-line2]');
    const statTrust = gateHost.querySelector('[data-htc-gate-stat-trust]');
    if (starsEl) {
      starsEl.innerHTML = htcGateTpStarsInnerHtml(Number.isFinite(trust) ? trust : 0);
    }
    if (strongEl) {
      strongEl.textContent = Number.isFinite(trust)
        ? `Rated ${trust.toFixed(1)}/5 on Trustpilot`
        : 'Rated —/5 on Trustpilot';
    }
    if (line2) {
      if (Number.isFinite(count) && count > 0) {
        line2.textContent = `Voted No.1 hot tub brand in the UK · ${count.toLocaleString()} reviews`;
      } else {
        line2.textContent = 'Voted No.1 hot tub brand in the UK';
      }
    }
    if (statTrust) {
      statTrust.textContent = Number.isFinite(trust) ? `${trust.toFixed(1)}★` : '—';
    }
  }

  function fetchHtcScoreRow() {
    return fetch(HTC_SCORE_URL, { headers: HTC_SCORE_HEADERS })
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.json();
      })
      .then((data) => (Array.isArray(data) && data.length > 0 ? data[0] : null));
  }

  function initLeadGate(section) {
    const clearBootLock = () => {
      document.documentElement.classList.remove(HTC_LEAD_GATE_BOOT_LOCK_CLASS);
    };

    const root = section.querySelector('[data-htc-lead-gate-root]');
    if (!root) {
      clearBootLock();
      return;
    }

    for (let n = root.parentElement; n; n = n.parentElement) {
      if (typeof n.matches === 'function' && n.matches(SECTION_SELECTOR) && n !== section) {
        n.removeAttribute('data-htc-lead-gate-locked');
      }
    }
    const leadSlot = root.querySelector('[data-htc-lead-slot]');
    const leadTemplate = root.querySelector('[data-htc-lead-template]');
    const resultsTemplate = root.querySelector('[data-htc-results-template]');
    const resultsSlot = section.querySelector('[data-htc-results-slot]');
    if (!leadSlot || !leadTemplate || !resultsTemplate || !resultsSlot) {
      clearBootLock();
      return;
    }

    const tabs = section.querySelectorAll(TAB_SELECTOR);

    const getStorage = (key) => {
      if (!globalThis.localStorage) return null;
      return globalThis.localStorage.getItem(key);
    };

    const setStorage = (key, value) => {
      if (!globalThis.localStorage) return;
      globalThis.localStorage.setItem(key, value);
    };

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    /** @param {HTMLElement} targetEl @param {HTMLTemplateElement} templateEl */
    const renderInto = (targetEl, templateEl) => {
      targetEl.replaceChildren(templateEl.content.cloneNode(true));
    };

    const setLeadGateLocked = (locked) => {
      if (locked) section.setAttribute('data-htc-lead-gate-locked', '');
      else section.removeAttribute('data-htc-lead-gate-locked');
      tabs.forEach((t) => {
        if (locked) {
          t.setAttribute('disabled', '');
          t.setAttribute('aria-disabled', 'true');
        } else {
          t.removeAttribute('disabled');
          t.removeAttribute('aria-disabled');
        }
      });
    };

    const renderResults = () => {
      leadSlot.replaceChildren();
      setLeadGateLocked(false);
      renderInto(resultsSlot, resultsTemplate);
      initResults(section);
      clearBootLock();
    };

    const renderLeadGate = () => {
      setLeadGateLocked(true);
      renderInto(leadSlot, leadTemplate);

      const gateHost = leadSlot.querySelector('[data-htc-lead-gate]');
      applyHtcGateScoreRow(gateHost, null);
      fetchHtcScoreRow()
        .then((row) => applyHtcGateScoreRow(gateHost, row))
        .catch(() => {});

      const form = leadSlot.querySelector('[data-htc-lead-form]');
      if (!form) {
        clearBootLock();
        return;
      }

      initHtcCountryCombobox(form);

      const submitBtn = form.querySelector('[data-htc-lead-submit]');
      const emailInput = form.querySelector('[data-htc-lead-input="email"]');
      const countryInput = form.querySelector('[data-htc-lead-input="country"]');
      const ownershipInput = form.querySelector('[data-htc-lead-ownership]');
      const chipsRoot = form.querySelector('[data-htc-lead-chips]');

      const errorEls = {
        email: form.querySelector('[data-htc-lead-error="email"]'),
        country: form.querySelector('[data-htc-lead-error="country"]'),
        ownership: form.querySelector('[data-htc-lead-error="ownership"]'),
      };
      const fieldEls = {
        email: emailInput ? emailInput.closest('.gate__field') : null,
        country: countryInput ? countryInput.closest('.gate__field') : null,
        ownership: chipsRoot ? chipsRoot.closest('.gate__field') : null,
      };

      const setFieldError = (field, hasError) => {
        const fieldEl = fieldEls[field];
        const errorEl = errorEls[field];
        if (fieldEl) fieldEl.classList.toggle('gate__field--invalid', hasError);
        if (errorEl) errorEl.hidden = !hasError;
        if (field === 'email' && emailInput) emailInput.classList.toggle('error', hasError);
      };
      const clearAllErrors = () => {
        setFieldError('email', false);
        setFieldError('country', false);
        setFieldError('ownership', false);
      };

      const syncOwnershipFromChips = () => {
        if (!ownershipInput || !chipsRoot) return;
        const vals = Array.from(chipsRoot.querySelectorAll('[data-htc-lead-chip].is-active'))
          .map((b) => b.getAttribute('data-val') || '')
          .filter(Boolean);
        ownershipInput.value = vals.join(',');
      };

      chipsRoot?.addEventListener('click', (e) => {
        const chip = e.target.closest('[data-htc-lead-chip]');
        if (!chip || !chipsRoot.contains(chip)) return;
        const val = chip.getAttribute('data-val') || '';
        const isMulti = HTC_CHIP_MULTI.has(val);
        const isExclusive = HTC_CHIP_EXCLUSIVE.has(val);

        if (isExclusive) {
          chipsRoot.querySelectorAll('[data-htc-lead-chip]').forEach((c) => c.classList.remove('is-active'));
          chip.classList.add('is-active');
        } else if (isMulti) {
          chipsRoot.querySelectorAll('[data-htc-lead-chip]').forEach((c) => {
            const v = c.getAttribute('data-val') || '';
            if (HTC_CHIP_EXCLUSIVE.has(v)) c.classList.remove('is-active');
          });
          chip.classList.toggle('is-active');
        }
        syncOwnershipFromChips();
        setFieldError('ownership', false);
      });

      syncOwnershipFromChips();

      const validate = () => {
        const email = (emailInput?.value || '').trim();
        const country = (countryInput?.value || '').trim();
        const calculator_ownership = (ownershipInput?.value || '').trim();

        const hasEmailError = !email || !emailRegex.test(email);
        const hasCountryError = !country;
        const hasOwnershipError = !calculator_ownership;
        setFieldError('email', hasEmailError);
        setFieldError('country', hasCountryError);
        setFieldError('ownership', hasOwnershipError);
        if (hasEmailError || hasCountryError || hasOwnershipError) return null;
        return { email, country, calculator_ownership };
      };

      emailInput?.addEventListener('input', () => {
        if ((emailInput.value || '').trim()) setFieldError('email', false);
      });
      countryInput?.addEventListener('change', () => {
        if ((countryInput.value || '').trim()) setFieldError('country', false);
      });

      const formErrorEl = form.querySelector('[data-htc-lead-form-error]');
      const setFormError = (message) => {
        if (!formErrorEl) return;
        if (message) {
          formErrorEl.textContent = message;
          formErrorEl.hidden = false;
        } else {
          formErrorEl.textContent = '';
          formErrorEl.hidden = true;
        }
      };

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        clearAllErrors();
        setFormError('');

        const values = validate();
        if (!values) return;
        if (submitBtn) submitBtn.disabled = true;

        const payload = {
          ...values,
          source: 'hot_tube_water_calculator',
          submittedAt: new Date().toISOString(),
        };

        const KPI = globalThis.KlaviyoProfileImport;
        const anonKey = typeof globalThis.SUPABASE_ANON_KEY === 'string' ? globalThis.SUPABASE_ANON_KEY.trim() : '';
        const newsletterListId =
          typeof globalThis.KLAVIYO_NEWSLETTER_LIST_ID === 'string' ? globalThis.KLAVIYO_NEWSLETTER_LIST_ID.trim() : '';

        if (KPI && anonKey) {
          if (!newsletterListId) {
            console.warn('[HTC LeadGate] Set Klaviyo Newsletter list ID in theme section (Hot tube water calculator).');
          }
          try {
            const raw = KPI.collectFormAsObject(form);
            const merged = {
              ...raw,
              source: 'hot_tube_water_calculator',
              submittedAt: new Date().toISOString(),
            };
            const klaviyoBody = KPI.buildProfileImportBody(merged);
            const res = await KPI.postProfileImportViaSupabase({
              supabaseAnonKey: anonKey,
              klaviyoBody,
              klaviyoNewsletterListId: newsletterListId,
            });
            if (!res.ok) {
              const errText = await res.text();
              throw new Error(errText || res.statusText);
            }
          } catch (err) {
            console.error('[HTC LeadGate] Supabase/Klaviyo:', err);
            setFormError("We couldn't save your details. Please try again.");
            if (submitBtn) submitBtn.disabled = false;
            return;
          }
        } else if (!anonKey) {
          console.warn(
            '[HTC LeadGate] Add Supabase anon key in theme editor (Hot tube water calculator section) to sync leads.'
          );
        }

        setStorage(LEAD_DATA_KEY, JSON.stringify(payload));
        setStorage(LEAD_SUBMITTED_KEY, 'true');
        renderResults();
      });

      clearBootLock();
    };

    const isSubmitted = getStorage(LEAD_SUBMITTED_KEY) === 'true';
    if (isSubmitted) renderResults();
    else renderLeadGate();
  }

  function run() {
    const roots = document.querySelectorAll('[data-htc-lead-gate-root]');
    const processed = new WeakSet();
    for (const root of roots) {
      const section = root.closest(SECTION_SELECTOR);
      if (!section || processed.has(section)) continue;
      processed.add(section);
      initStickyTabsOffset(section);
      initSection(section);
      initActiveIngredientsToggle(section);
      initWaterSetupOptions(section);
      initReadings(section);
      initVolumeCalculator(section);
      initResults(section);
      initLeadGate(section);
      initGuide(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
